module.exports = __webpack_public_path__ + "media/images/athletes/123-dd72d9d55d36156cb303592e9e3992b6.png";